// src/directives/onlineOffline.js
import { useAuthStore } from '@/stores/auth-store.js';
import { watch } from 'vue';

function makeDirective(showWhenOnline) {
    return {
        mounted(el) {
            const store = useAuthStore();

            // update visibility based on store.getOnlineStatus
            const update = () => {
                const online = store.getOnlineStatus;
                el.style.display = online === showWhenOnline ? '' : 'none';
            };

            // Rendering follows the confirmed backend-connectivity state.
            // Native browser events are handled centrally by onlineCheckService;
            // navigator.onLine alone must never enable mutations.
            const stopWatcher = watch(() => store.getOnlineStatus, update, { immediate: true });

            el.__cleanup = () => {
                stopWatcher();
            };
        },
        unmounted(el) {
            el.__cleanup && el.__cleanup();
        },
    };
}

export const vOnline = makeDirective(true);
export const vOffline = makeDirective(false);
